import { FindingsList, type Finding } from './FindingsList';
import {
  NotableFindingsBlock,
  NotableFindingsCaption,
  NotableFindingsHeader,
  NotableFindingsTitle,
} from './NotableFindings.styled';

export interface NotableFindingsProps {
  title: string;
  note: string;
  findings: Finding[];
  blockTestId?: string;
}

export function NotableFindings({ title, note, findings, blockTestId }: NotableFindingsProps) {
  if (findings.length === 0) {
    return null;
  }

  return (
    <NotableFindingsBlock data-testid={blockTestId}>
      <NotableFindingsHeader>
        <NotableFindingsTitle>{title}</NotableFindingsTitle>
        <NotableFindingsCaption>{note}</NotableFindingsCaption>
      </NotableFindingsHeader>
      <FindingsList findings={findings} />
    </NotableFindingsBlock>
  );
}
